import OrdinaryAccident from './Ordinary/Accident';
import GroupAccident from './Group/Accident';
import NewYorkAccident from './NewYork/Accident';
import OrdinaryCancer from './Ordinary/Cancer';
import GroupCancer from './Group/Cancer';
import NewYorkCancer from './NewYork/Cancer';
import CriticalIllness from './Ordinary/CriticalIllness';
import OrdinaryDisability from './Ordinary/Disability';
import GroupDisability from './Group/Disability';
import NewYorkDisability from './NewYork/Disability';
import HeartStroke from './Ordinary/HeartStroke';
import Icrtn from './Ordinary/ICRTN';
import IWLContainer from './Ordinary/IWL';
import Shop from './Ordinary/Shop';
import PinCare from './Group/PinCare';
import GroupShop from './Group/Shop';
import UniversalLife from './Group/UniversalLife';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import {matchGLTERMByType} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GLTERM';
import {matchShopByType} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';
import {matchULByType} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/UniversalLife';
import React from 'react';
import './ProductRiders.sass';
import {Divider, Typography} from '@material-ui/core';
import {isLoadedPolicyTypes} from 'ApplicationEntry/models/PolicyTypes';
import {isValidCaseDetails} from 'ApplicationEntry/models/CaseDetails';
import {matchDisabilityByType} from 'ApplicationEntry/models/ProductsRiders/Disability/Disability';
import AccidentNewYork from './Group/AccidentNewYork';
import {matchCriticalIllnessByType} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/CriticalIllness';
import GroupCriticalIllness from './Group/GroupCriticalIllness';
import NYCriticalIllness from './NewYork/NYCritcalIllness';
import GLTERM from './Group/GLTERM';
import {matchCancerByType} from 'ApplicationEntry/models/ProductsRiders/Cancer/Cancer';
import GWL from 'ApplicationEntry/components/WorkFlow/ProductsRiders/Group/GWL';
import GroupCriticalIllnessNY from './Group/CriticalIllnessNY';
import {matchAccidentByType} from 'ApplicationEntry/models/ProductsRiders/Accident/Accident';
import {matchHeartStrokeByType} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/HeartStroke';
import {OrdinaryIwl} from 'ApplicationEntry/models/ProductsRiders/IWL/OrdinaryIWL';
import {GroupIWL} from 'ApplicationEntry/models/ProductsRiders/IWL/GroupIWL';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import AIP from './Group/AIP';
import {matchAIPByType} from 'ApplicationEntry/models/ProductsRiders/AIP/AIP';
import {Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';

type ProductRidersProps = {
  application: InvalidApplication | ValidApplication;
  mode: ApplicationModeType;
};

const ProductRiders = ({application, mode}: ProductRidersProps) => {
  const {
    accident,
    caseDetails,
    cancer,
    criticalIllness,
    disability,
    icrtn,
    iwl,
    heartStroke,
    shop,
    pinCare,
    universalLife,
    accidentNewYork,
    glterm,
    criticalIllnessNY,
    aip,
    billingAgent,
    premium,
    applicantDemographics,
  } = application;
  let products: Product[] = [];
  if (
    isLoadedPolicyTypes(caseDetails.productType) &&
    (isValidCaseDetails(caseDetails) || mode === ApplicationModeType.Quality)
  ) {
    products = caseDetails.productType.selectedPolicyTypes;
  }

  const getHeader = (header: string) => {
    return (
      <div className="product-riders-section__title-container">
        <Typography variant="subtitle1" className="product-riders-section__title-container-title">
          {header}
        </Typography>
      </div>
    );
  };

  return (
    <div className="product-riders-policy-type-container">
      {products.map(product => {
        switch (product.productGroup!?.toUpperCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
            return (
              <div id="critical-illness-container" key="critical-illness-container">
                {getHeader(product.name!)}
                {matchCriticalIllnessByType({
                  Ordinary: ordinaryApp => <CriticalIllness caseDetails={caseDetails} criticalIllness={ordinaryApp} />,
                  Group: groupApp => (
                    <GroupCriticalIllness
                      caseDetails={caseDetails}
                      criticalIllness={groupApp}
                      billingAgent={billingAgent}
                      applicantDemographics={applicantDemographics}
                    />
                  ),
                  NewYork: nyApp => <NYCriticalIllness criticalIllness={nyApp} />,
                  _: () => null,
                })(criticalIllness)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Cancer]:
            return (
              <div id="cancer-container" key="cancer-container">
                {getHeader(product.name!)}
                {matchCancerByType({
                  Group: groupCancer => (
                    <GroupCancer cancer={groupCancer} caseDetails={caseDetails} billingAgent={billingAgent} />
                  ),
                  Ordinary: ordinaryCancer => <OrdinaryCancer cancer={ordinaryCancer} />,
                  NewYork: newYorkCancer => <NewYorkCancer cancer={newYorkCancer} />,
                })(cancer)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.DitWuNY]:
          case ProductRiderGroups[ProductsRidersPolicyType.Disability]:
            return (
              <div id="disability-container" key="disability-container">
                {getHeader(product.name!)}
                {matchDisabilityByType({
                  Group: groupDisability => <GroupDisability disability={groupDisability} caseDetails={caseDetails} />,
                  Ordinary: ordinaryDisability => <OrdinaryDisability disability={ordinaryDisability} />,
                  NewYork: newYorkDisability => (
                    <NewYorkDisability disability={newYorkDisability} product={product.productGroup!} />
                  ),
                })(disability)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Shop]:
            return (
              <div id="shop-container" key="shop-container">
                {matchShopByType({
                  Ordinary: ordinaryApp => (
                    <>
                      {getHeader(product.name!)}
                      <Shop shop={ordinaryApp} />
                    </>
                  ),
                  Group: groupApp => (
                    <>
                      {getHeader(product.name!)}
                      <GroupShop
                        shop={groupApp}
                        caseDetails={caseDetails}
                        billingAgent={billingAgent}
                        applicantDemographics={applicantDemographics}
                      />
                    </>
                  ),
                  _: () => null,
                })(shop)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Icrtn]:
            return (
              <div id="icrtn-container" key="icrtn-container">
                {getHeader(product.name!)}
                <Icrtn icrtn={icrtn} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.HeartStroke]:
            return (
              <div id="heart-stroke-container" key="heart-stroke-container">
                {getHeader(product.name!)}
                {matchHeartStrokeByType({
                  Ordinary: ordinaryHeartStroke => <HeartStroke heartStroke={ordinaryHeartStroke} />,
                  _: () => null,
                })(heartStroke)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Iwl]:
            return (
              <div id="iwl-container" key="iwl-container">
                {getHeader(product.name!)}
                <IWLContainer iwl={iwl as OrdinaryIwl} plans={product.plans!} billingAgent={billingAgent} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Gwl]:
            return (
              <div id="gwl-container" key="gwl-container">
                {getHeader(product.name!)}
                <GWL iwl={iwl as GroupIWL} plans={product.plans!} caseDetails={caseDetails} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Accident]:
            return (
              <div id="accident-container" key="accident-container">
                {getHeader(product.name!)}
                {matchAccidentByType({
                  Group: groupAccident => (
                    <GroupAccident
                      accident={groupAccident}
                      caseDetails={caseDetails}
                      situs={application.applicantDemographics.state}
                      billingAgent={billingAgent}
                    />
                  ),
                  Ordinary: ordinaryAccident => (
                    <OrdinaryAccident
                      accident={ordinaryAccident}
                      agentList={application.agentList}
                      situs={application.applicantDemographics.state}
                      mode={mode}
                    />
                  ),
                  NewYork: newYorkAccident => <NewYorkAccident accident={newYorkAccident} />,
                })(accident)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.PinCare]:
            return (
              <div id="pin-care-container" key="pin-care-container">
                {getHeader(product.name!)}
                <PinCare caseDetails={caseDetails} pinCare={pinCare} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.UniversalLife]:
            return (
              <div id="universallife-container" key="universallife-container">
                {getHeader(product.name!)}
                {matchULByType({
                  Group: groupApp => <UniversalLife universalLife={groupApp} caseDetails={caseDetails} />,
                  _: () => null,
                })(universalLife)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.AccidentNewYork]:
            return (
              <div id="accident-new-york-container" key="accident-new-york-container">
                {getHeader(product.name!)}
                <AccidentNewYork accidentNewYork={accidentNewYork} caseDetails={caseDetails} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.GLTerm]:
            return (
              <div id="glterm-container" key="glterm-container">
                {getHeader(product.name!)}
                {matchGLTERMByType({
                  Group: groupApp => <GLTERM glterm={groupApp} caseDetails={caseDetails} />,
                  _: () => null,
                })(glterm)}
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllnessNY]:
            return (
              <div id="critical-illness-NY-container" key="critical-illness-NY-container">
                {getHeader(product.name!)}
                <GroupCriticalIllnessNY criticalIllnessNY={criticalIllnessNY} caseDetails={caseDetails} />
              </div>
            );
          case ProductRiderGroups[ProductsRidersPolicyType.Aip]:
            return (
              <div id="aip-container" key="aip-container">
                {getHeader(product.name!)}
                {matchAIPByType({
                  Group: groupApp => (
                    <AIP premium={premium} aip={groupApp} caseDetails={caseDetails} billingAgent={billingAgent} />
                  ),
                  _: () => null,
                })(aip)}
              </div>
            );
          default:
            return (
              <div id="default-container" className="default-container" key="default-container">
                {getHeader(product.name!)}
                <span>{product.name!}</span>
              </div>
            );
        }
      })}
      <Divider className="application-form__actions-divider" />
    </div>
  );
};

export default ProductRiders;
